/**
 * @fileoverview SubscribeNewsletterSwitch — Blueprint switch control with a
 * "Subscribe to newsletter" label, sized for the footer of dialogs like
 * WhatsNewDialog. Wraps Blueprint's `Switch` and exposes controlled and
 * uncontrolled usage.
 *
 * Foundry mapping: `release-notes__subscription-toggle__o4fbv4` — a
 * `bp6-control bp6-switch` rendered next to footer action buttons.
 */

import { Switch } from "@blueprintjs/core";
import type { ReactElement } from "react";

interface SubscribeNewsletterSwitchProps {
  label?: string;
  checked?: boolean;
  defaultChecked?: boolean;
  onChange?: (checked: boolean) => void;
  className?: string;
}

export function SubscribeNewsletterSwitch({
  label = "Subscribe to newsletter",
  checked,
  defaultChecked,
  onChange,
  className,
}: SubscribeNewsletterSwitchProps): ReactElement {
  return (
    <Switch data-testid="subscribe-newsletter-switch"
      className={["bp-subscribe-newsletter-switch", className].filter(Boolean).join(" ")}
      label={label}
      checked={checked}
      defaultChecked={defaultChecked}
      onChange={(event) => onChange?.(event.currentTarget.checked)}
    />
  );
}
